import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import Alert from '@material-ui/lab/Alert';

// GET - POST 
import useAxios from "../../../request/useAxios";

// form validation
import { useForm } from "react-hook-form";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Travelling Salesman
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn(props) {
  const { useLogin, useSignup, useAlert } = props;

  // const { useLogin, useSignup, useAlert } = props.useLogin;
  // const { setSignup } = props.useSignup;
  // const { alert } = props.useAlert;

  const { post } = useAxios();

  const { register, errors, handleSubmit, setError } = useForm();

  const classes = useStyles();

  function handleLoginSubmit(e) {
    const username = e.username;
    const password = e.password;
    // const password = "password";

    // POST login
    post(
      "/auth/salesman-login",
      { username: username, password: password },
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((data) => {
        localStorage.setItem("TS", JSON.stringify({ token: data.token, userId: data.userId }));
        useLogin.setLogin(true);
      })
      .catch((error) => {
        setError("password", { type: "manual", message: "Hibás felhasználónév vagy jelszó." });
        setError("username", { type: "manual", message: "Hibás felhasználónév vagy jelszó." });
      });

    window.history.replaceState(null, '', '/');
  }

  function handleLogupSubmit(e) {
    e.preventDefault();
    useSignup.setSignup(true);
  }

  return (
    <Container component="main" maxWidth="xs">
      {/* {console.log('e: ', errors)} */}
      {useAlert.alert &&
        <Alert variant="filled" severity="success">
          Köszönjük a regisztrációt.<br />Most már be tud jelentkezni.
        </Alert>
      }
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Bejelentkezés
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit(handleLoginSubmit)}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Felhasználónév"
            name="username"
            autoComplete="username"
            autoFocus
            inputRef={
              register(
                {
                  required: "Kötelező megadni"
                }
              )
            }
            error={errors.username}
            helperText={errors.username && errors.username.message}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Jelszó"
            type="password"
            id="password"
            autoComplete="current-password"
            inputRef={
              register(
                {
                  required: "Kötelező megadni"
                }
              )
            }
            error={errors.password}
            helperText={errors.password && errors.password.message}
          />
          {/* <FormHelperText
            id="my-helper-text"
            error={errors.login}
          >
            {errors.login && errors.login.message}
          </FormHelperText> */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Bejelentkezés
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                Elfelejtette a jelszavát?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2" onClick={handleLogupSubmit}>
                {"Nincs fiókja? Regisztráljon"}
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}